import { render } from "./QuestionTwo.vue?vue&type=template&id=cf55c49e&scoped=true"
const script = {}

import "./QuestionTwo.vue?vue&type=style&index=0&id=cf55c49e&scoped=true&lang=scss"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf55c49e"]])

export default __exports__